import styled from 'styled-components';

// import { CartSummary } from '../../../Cart/components';
import { useBreakpoint } from '../../../hooks/useBreakpoint';
import { TwoColumn } from '../../../Layout/components/TwoColumn';
import { OrderSummary } from '../OrderSummary';


export type LayoutProps = {
	title?: string;
	//children?: JSX.Element[] | JSX.Element
	children?: React.ReactElement
};

export const Layout = ({title, children}: LayoutProps) => {
	const breakpointActive = useBreakpoint('lg');

	return (
		<Container>
			<TwoColumn
				title={title}
				breakpoint={'lg'}
			>
				{breakpointActive ? <OrderSummary /> : <></>}
				{children? children : <></>}
			</TwoColumn>
		</Container>
	);
};

const Container = styled.div`
	display: flex;
	justify-content: flex-start;
	width: 1140px;
	max-width: 100%;
`;
